export const translations = {
  ru: {
    title: 'Калькулятор счёта EAC',
    subtitle: 'Electricity Authority of Cyprus - Расчёт стоимости электроэнергии',
    inputData: 'Ввод данных',
    meterReadings: 'Показания счётчика',
    consumptionInput: 'Потребление',
    previousReading: 'Предыдущие показания (кВт·ч)',
    currentReading: 'Текущие показания (кВт·ч)',
    consumption: 'Потребление (кВт·ч)',
    consumptionResult: 'Потребление:',
    adjustRates: 'Настроить тарифы',
    hideRates: 'Скрыть тарифы',
    rates: 'Тарифы (€)',
    reset: 'Сброс',
    resetRates: 'Сбросить тарифы к стандартным значениям',
    calculation: 'Расчёт стоимости электроэнергии',
    consumptionLabel: 'Потребление:',
    chargesTitle: 'Charges of Tariff 01 ——————————————————————————————————',
    electricityGeneration: 'Electricity Generation',
    networkUsage: 'Network Usage',
    ancillaryServices: 'Ancillary Services',
    meterDataManagement: 'Meter Data Management',
    electricitySupply: 'Electricity Supply',
    totalBasicPrice: 'Total Basic Price',
    fuelAdjustment: 'Fuel Adjustment',
    publicServiceObligations: 'Public Service Obligations',
    totalSubjectToVAT: 'Total subject to VAT',
    resESFund: 'RES & ES Fund',
    vat: 'НДС',
    totalCharges: 'Total charges for the period',
    amountDue: 'Сумма к оплате',
    note: 'Примечание:',
    noteText: 'Расчёт основан на тарифах EAC (Electricity Authority of Cyprus). Актуальные тарифы могут отличаться. Используйте настройки для корректировки под ваши условия.',
    officialTariffs: 'Официальные тарифы EAC',
    rateNames: {
      electricityGeneration: 'Electricity Generation:',
      networkUsage: 'Network Usage:',
      ancillaryServices: 'Ancillary Services:',
      meterDataManagement: 'Meter Data Mgmt:',
      electricitySupply: 'Electricity Supply:',
      fuelAdjustment: 'Fuel Adjustment:',
      publicServiceObligations: 'Public Service Obl:',
      resESFund: 'RES & ES Fund:',
      vatRate: 'НДС (%):'
    },
    excludeFixedPrices: 'Исключить фиксированные платежи'
  },
  en: {
    title: 'EAC Bill Calculator',
    subtitle: 'Electricity Authority of Cyprus - Electricity Cost Calculation',
    inputData: 'Input Data',
    meterReadings: 'Meter Readings',
    consumptionInput: 'Consumption',
    previousReading: 'Previous Reading (kWh)',
    currentReading: 'Current Reading (kWh)',
    consumption: 'Consumption (kWh)',
    consumptionResult: 'Consumption:',
    adjustRates: 'Adjust Rates',
    hideRates: 'Hide Rates',
    rates: 'Rates (€)',
    reset: 'Reset',
    resetRates: 'Reset rates to default values',
    calculation: 'Electricity Cost Calculation',
    consumptionLabel: 'Consumption:',
    chargesTitle: 'Charges of Tariff 01 ——————————————————————————————————',
    electricityGeneration: 'Electricity Generation',
    networkUsage: 'Network Usage',
    ancillaryServices: 'Ancillary Services',
    meterDataManagement: 'Meter Data Management',
    electricitySupply: 'Electricity Supply',
    totalBasicPrice: 'Total Basic Price',
    fuelAdjustment: 'Fuel Adjustment',
    publicServiceObligations: 'Public Service Obligations',
    totalSubjectToVAT: 'Total subject to VAT',
    resESFund: 'RES & ES Fund',
    vat: 'VAT',
    totalCharges: 'Total charges for the period',
    amountDue: 'Amount Due',
    note: 'Note:',
    noteText: 'Calculation is based on EAC (Electricity Authority of Cyprus) tariffs. Current tariffs may differ. Use settings to adjust to your conditions.',
    officialTariffs: 'Official EAC Tariffs',
    rateNames: {
      electricityGeneration: 'Electricity Generation:',
      networkUsage: 'Network Usage:',
      ancillaryServices: 'Ancillary Services:',
      meterDataManagement: 'Meter Data Mgmt:',
      electricitySupply: 'Electricity Supply:',
      fuelAdjustment: 'Fuel Adjustment:',
      publicServiceObligations: 'Public Service Obl:',
      resESFund: 'RES & ES Fund:',
      vatRate: 'VAT (%):'
    },
    excludeFixedPrices: 'Exclude Fixed Charges'
  }
};
